export const imprint = {
  lastUpdated: 'January 26, 2026',
  lastUpdatedLabel: 'Last Updated',
  
  meta: {
    title: 'Imprint',
    description: 'Imprint for TerminTeiler - Information according to § 5 Digital Services Act (DDG)'
  },
  
  content: {
    title: 'Imprint',
    ddg: 'Information according to § 5 Digital Services Act (DDG)',
    
    description: `
      <p><strong>TerminTeiler</strong><br/>
      Digital platform for voluntary sharing of doctor appointments<br/>
      (Project in founding and testing phase / MVP)</p>
    `,
    
    provider: {
      title: 'Provider / Responsible Party:',
      name: 'Feryal Catoglu'
    },
    
    address: {
      title: 'Address (service of process):',
      name: 'TerminTeiler-Startpunkt57',
      street: 'Sandstraße 26',
      city: '57072 Siegen',
      country: 'Germany'
    },
    
    contact: {
      title: 'Contact:',
      email: 'Email: support@terminteiler.com',
      phone: 'Phone: +49 152 38556881'
    },
    
    contentResponsible: {
      title: 'Responsible for content according to § 18 para. 2 Media State Treaty (MStV)',
      name: 'Feryal Catoglu',
      note: '(Address as above)'
    },
    
    coFounders: {
      title: 'Co-Founders / Team:',
      members: [
        {
          name: 'Feryal Catoglu',
          role: 'Founder & Visionary'
        },
        {
          name: 'Faheem Babar',
          role: 'Co-Founder & Project Manager'
        },
        {
          name: 'Haitham El Euch',
          role: 'Co-Founder & Software Developer'
        },
        {
          name: 'Jouhaina Salsabil El Euch',
          role: 'Co-Founder & Software Developer'
        }
      ]
    },
    
    partner: {
      title: 'Partner / Supporting organization',
      organizationName: 'TerminTeiler-Startpunkt57 – The Initiative for Founders (registered association)',
      street: 'Sandstraße 26',
      city: '57072 Siegen',
      country: 'Germany'
    },
    
    projectStatus: {
      title: 'Project Status / Notice',
      content: `
        <p>TerminTeiler is currently in a non-commercial testing and pilot phase (MVP).</p>
        <p>The platform serves exclusively for technical testing, internal tests, and user feedback.</p>
        <p>No medical advice, no legally binding appointment mediation, and no cooperation with medical practices takes place.</p>
      `
    },
    
    liabilityContent: {
      title: 'Liability for Content',
      content: `
        <p>As a service provider, I am responsible for my own content on these pages according to general laws pursuant to § 7 para. 1 DDG.</p>
        <p>However, according to §§ 8 to 10 DDG, I am not obliged to monitor transmitted or stored third-party information.</p>
        <p>No liability is assumed for the accuracy, completeness, or timeliness of the provided content.</p>
      `
    },
    
    liabilityLinks: {
      title: 'Liability for External Links',
      content: `
        <p>This website may contain links to external websites of third parties, over whose content I have no influence.</p>
        <p>The respective provider or operator of the linked pages is always responsible for the content of the linked pages.</p>
        <p>Upon becoming aware of legal violations, such links will be removed immediately.</p>
      `
    },
    
    copyright: {
      title: 'Copyright',
      content: `
        <p>The content of this website is subject to German copyright law.</p>
        <p>Use outside the legal limits requires prior written consent.</p>
      `
    },
    
    disputeResolution: {
      title: 'Online Dispute Resolution',
      content: `
        <p>Platform of the EU Commission:<br/>
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a></p>
        <p>I am not obliged and not willing to participate in a dispute resolution procedure.</p>
      `
    }
  }
};
